import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  DialogActions,
} from '@mui/material';
import { PrimaryButton } from '../common';
import SaveDialog from '../SaveDialog';
import SubmitDialogs from '../SubmitDialogs';
import FailedSubmissionDialog from '../../../FailedSubmissionDialog';
import FormSubmitLoader from '../../FormSubmitLoader';

const FormDialogManager = ({
  saveDialog = false,
  showSubmissionDialog = false,
  showFailedSubmissionDialog = false,
  pagesErrorDialog = false,
  isSubmitting = false,
  formFailures = {},
  pagesError = [],
  formState = {},
  onCloseSaveDialog,
  onCloseSubmissionDialog,
  onCloseFailedSubmissionDialog,
  onClosePagesErrorDialog,
}) => {
  const renderSaveDialog = () => {
    if (!saveDialog) return null;

    return (
      <SaveDialog
        open={saveDialog}
        close={() => {
          onCloseSaveDialog();
        }}
        formFailures={formFailures}
      />
    );
  };

  const renderSubmitDialogs = () => {
    if (!showSubmissionDialog) return null;

    return (
      <SubmitDialogs
        showSubmissionDialog={showSubmissionDialog}
        closeSubmissionDialog={onCloseSubmissionDialog}
        formState={formState}
      />
    );
  };

  const renderFailedSubmissionDialog = () => {
    if (!showFailedSubmissionDialog) return null;

    return (
      <FailedSubmissionDialog
        formFailures={formFailures}
        close={onCloseFailedSubmissionDialog}
      />
    );
  };

  const renderPagesErrorDialog = () => {
    if (!pagesErrorDialog) return null;

    return (
      <Dialog open={pagesErrorDialog}>
        <DialogTitle>Required questions must be answered</DialogTitle>

        <DialogContent>
          <p>
            The following questions are required and must be answered before
            this form can be submitted:
          </p>
          <List>
            {pagesError.map((aPageError, index) => {
              return (
                <ListItem
                  key={index}
                  style={{ paddingBottom: '4px', paddingTop: '4px' }}
                >
                  "{aPageError.questionTitle}" on "{aPageError.pageTitle}"
                </ListItem>
              );
            })}
          </List>
        </DialogContent>

        <DialogActions>
          <PrimaryButton onClick={onClosePagesErrorDialog}>Close</PrimaryButton>
        </DialogActions>
      </Dialog>
    );
  };

  const renderFormSubmitLoader = () => {
    if (!isSubmitting) return null;

    return <FormSubmitLoader open={isSubmitting} />;
  };

  return (
    <>
      {renderSaveDialog()}
      {renderSubmitDialogs()}
      {renderFailedSubmissionDialog()}
      {renderPagesErrorDialog()}
      {renderFormSubmitLoader()}
    </>
  );
};

export default FormDialogManager;
